// extracted by mini-css-extract-plugin
export default {"companyTooltip":"styles_companyTooltip__aAuYg"};